import { withFormikField } from "@/formikComponents";
import { TypeaheadRoles } from "@/views/components/Typeaheads";

export const FormikTypeaheadRoles = withFormikField(TypeaheadRoles);
